module.exports = __webpack_public_path__ + "fonts/GeneralSans-Regular.5b248549.ttf";